"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Aegis = require("aegis-web-sdk");
// import packageJson from "../../package.json"; 
var aegis = new Aegis({
    id: "iHWefAYqDNAiuxNMQZ",
    reportApiSpeed: true,
    reportAssetSpeed: true,
    version: "1.3.0",
});
var loginSuccess = function (SDKAppID) {
    aegis.reportEvent({
        name: 'login',
        ext1: 'login-success',
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var loginFailed = function (SDKAppID, errorMessage) {
    aegis.reportEvent({
        name: 'login',
        ext1: "login-failed-".concat(errorMessage),
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var loginWithTUICoreSuccess = function (SDKAppID) {
    aegis.reportEvent({
        name: 'loginWithTUICore',
        ext1: 'loginWithTUICore-success',
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var loginWithTUICoreFailed = function (SDKAppID, errorMessage) {
    aegis.reportEvent({
        name: 'loginWithTUICore',
        ext1: "loginWithTUICore-failed-".concat(errorMessage),
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var loginWithTIMSuccess = function (SDKAppID) {
    aegis.reportEvent({
        name: 'loginWithTIM',
        ext1: 'loginWithTIM-success',
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var loginWithTIMFailed = function (SDKAppID, errorMessage) {
    aegis.reportEvent({
        name: 'loginWithTIM',
        ext1: "loginWithTIM-failed-".concat(errorMessage),
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var switchCallType = function (SDKAppID) {
    aegis.reportEvent({
        name: 'switchCallType',
        ext1: 'switchCallType-success',
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var callSuccess = function (SDKAppID, callType, typeString) {
    aegis.reportEvent({
        name: "".concat(callType, "-").concat(typeString),
        ext1: "".concat(callType, "-").concat(typeString, "-success"),
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var callFailed = function (SDKAppID, callType, typeString, errorMessage) {
    aegis.reportEvent({
        name: "".concat(callType, "-").concat(typeString),
        ext1: "".concat(callType, "-").concat(typeString, "-failed-").concat(errorMessage),
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var MinimizeSuccess = function (SDKAppID) {
    aegis.reportEvent({
        name: 'Minimized',
        ext1: "Minimized-success",
        ext2: 'webTUICallKit',
        ext3: SDKAppID.toString()
    });
};
var logReporter = {
    loginSuccess: loginSuccess,
    loginFailed: loginFailed,
    loginWithTUICoreSuccess: loginWithTUICoreSuccess,
    loginWithTUICoreFailed: loginWithTUICoreFailed,
    loginWithTIMSuccess: loginWithTIMSuccess,
    loginWithTIMFailed: loginWithTIMFailed,
    switchCallType: switchCallType,
    callSuccess: callSuccess,
    callFailed: callFailed,
    MinimizeSuccess: MinimizeSuccess
};
exports.default = logReporter;
